import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as applicationActions from "../../actions/application";
import { APPLICATION_CONTEXTS } from "../../constants";
import NavigationBar from "../common/navigationBar";
import ImageBackground from "../common/imageBackground";
import ImageHeader from "../common/imageHeader";

class Menu extends Component {
  /**************
   * Properties *
   **************/

  menuDisplays = [
    {
      src: require("./images/1_RoomControls_Temperature_HL.png"),
      left: null,
      right: 1,
      up: null,
      down: 4,
      goTo: "temperature",
    },
    {
      src: require("./images/2_RoomControls_AllLights_HL.png"),
      left: 0,
      right: 2,
      up: null,
      down: 5,
      goTo: "allLights",
    },
    {
      src: require("./images/3_RoomControls_ReadingLight_HL.png"),
      left: 1,
      right: 3,
      up: null,
      down: 6,
      goTo: "readingLight",
    },
    {
      src: require("./images/4_RoomControls_BedLight_HL.png"),
      left: 2,
      right: 8,
      up: null,
      down: 7,
      goTo: "bedLight",
    },
    {
      src: require("./images/5_RoomControls_EnvironmentPresets_HL.png"),
      left: null,
      right: 5,
      up: 0,
      down: null,
      goTo: "presets",
    },
    {
      src: require("./images/6_RoomControls_AllShades_HL.png"),
      left: 4,
      right: 6,
      up: 1,
      down: null,
      goTo: "allShades",
    },
    {
      src: require("./images/7_RoomControls_BedShades_HL.png"),
      left: 5,
      right: 7,
      up: 2,
      down: null,
      goTo: "bedShade",
    },
    {
      src: require("./images/8_RoomControls_SolarShades_HL.png"),
      left: 6,
      right: 8,
      up: 3,
      down: null,
      goTo: "solarShades",
    },
    {
      src: require("./images/9_RoomControls_WallLight_HL.png"),
      left: 3,
      right: null,
      up: null,
      down: null,
      goTo: "wallLight",
    },
  ];

  state = {
    menuPosition: 0,
    navigationBar: {
      back: true,
      backRoute: "/main_menu",
      mainMenu: true,
      navigate: true,
    },
    page: 1
  };

  constructor(props) {
    super(props);
    this.handleOnKeyUp = this.handleOnKeyUp.bind(this);
  }

  componentWillMount() {
    document.addEventListener("keyup", this.handleOnKeyUp, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keyup", this.handleOnKeyUp);
  }

  handleOnKeyUp(event) {
    if (this.props.context !== APPLICATION_CONTEXTS.SERVICES) {
      return;
    }
    switch (event.key) {
      case "ArrowLeft":
        this.moveMenuPosition("left");
        break;
      case "ArrowRight":
        this.moveMenuPosition("right");
        break;
      case "ArrowDown":
        this.moveMenuPosition("down");
        break;
      case "ArrowUp":
        this.moveMenuPosition("up");
        break;
      case "Enter":
        this.goToOptions();
        break;
      case "b":
        this.props.history.push("/main_menu");
        break;
      default:
    }
  }

  moveMenuPosition(direction) {
    const curIndex = this.state.menuPosition;
    if (this.menuDisplays[curIndex][direction] !== null) {
      this.setState({
        menuPosition: this.menuDisplays[curIndex][direction],
      });
    }
    if (this.state.menuPosition >= 8) {
      this.setState({
        page: 2
      })
    } else {
      this.setState({
        page: 1,
      });
    }
  }

  goToOptions() {
    if (this.props.context === APPLICATION_CONTEXTS.SERVICES) {
      const curIndex = this.state.menuPosition;
      if (this.menuDisplays[curIndex].goTo) {
        this.props.history.push(
          `/environmental_controls/${this.menuDisplays[curIndex].goTo}`
        );
      }
    }
  }

  handleClick(idx) {
    this.setState({
      menuPosition: idx,
    });
    if (this.menuDisplays[idx].goTo) {
      this.props.history.push(
        `/environmental_controls/${this.menuDisplays[idx].goTo}`
      );
    }
  }

  handlePageSwitch() {
    if(this.state.page === 1) {
      this.setState({
        menuPosition: 8,
        page: 2
      });
    } else if (this.state.page === 2) {
      this.setState({
        menuPosition: 0,
        page: 1,
      });
    }
  }

  render() {

    return (
      <div className="environmental-controls">
        <ImageBackground id="background" />
        <ImageHeader src={this.menuDisplays[this.state.menuPosition].src} />
        {this.state.page === 1 ? (
          <>
            <button
              className="temp-link"
              onClick={() => this.handleClick(0)}
            ></button>
            <button
              className="all-lights"
              onClick={() => this.handleClick(1)}
            ></button>
            <button
              className="read-light"
              onClick={() => this.handleClick(2)}
            ></button>
            <button
              className="bed-light"
              onClick={() => this.handleClick(3)}
            ></button>
            <button
              className="presets"
              onClick={() => this.handleClick(4)}
            ></button>
            <button
              className="all-shades"
              onClick={() => this.handleClick(5)}
            ></button>
            <button
              className="bed-shade"
              onClick={() => this.handleClick(6)}
            ></button>
            <button
              className="solar-shade"
              onClick={() => this.handleClick(7)}
            ></button>
            <button
              className="next-page"
              onClick={() => this.handlePageSwitch()}
            ></button>
          </>
        ) : (
          <>
            <button
              className="wall-light"
              onClick={() => this.handleClick(8)}
            ></button>
            <button
              className="prev-page"
              onClick={() => this.handlePageSwitch()}
            ></button>
          </>
        )}

        <NavigationBar className="nav" {...this.state.navigationBar} />
      </div>
    );
  }
}

const ConnectedMenu = connect(
  (state) => ({
    context: state.application.currentContext,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(Menu);

export default withRouter(ConnectedMenu);
